export default __webpack_public_path__ + "static/media/mq-new-1.1e6b5bc5.jpg";